
var React = require("react");

class ActionDropdown extends React.Component  {
    constructor(){
        super()

        this.onClick = this.onClick.bind(this);
        this.toggleShow = this.toggleShow.bind(this);
    }

    toggleShow(addListen = false){
        this.divShow.classList.toggle("show");
    }

    onClick(name){
        if(this.props.action[name]){
            this.props.action[name](this.props.handleError, this.props.resource, this.props.setConfirmation, this.props.setLoading, this.props.setError, name)
        }
    }

    render(){
        const { 
            resource, 
            action,
            setConfirmation, 
            setLoading, 
            setError, 
            text= "", 
            baseClass = "",
            gridClass = "",
            hideArrow=false,
            addedClass = "",
            tooltipPos=""
        } = this.props;

        var arrow = (!hideArrow)? "arrow":"";

        return <div className={`${baseClass} options ${gridClass}`}>
            <button className={`button ${addedClass}`} onClick={this.toggleShow} ref={div => this.headedShow = div}>{text}</button>
            <div className={`${baseClass}__container dropdown ${arrow}`} ref={div => this.divShow = div}>
                {
                    Object.keys(action).map(actionName =>
                        <a className="dropdown-item" 
                           key={actionName}
                           onMouseDown={()=>this.onClick(actionName)}>
                           {actionName}
                        </a>
                    )
                }
            </div>
        </div>
    }
}

module.exports = ActionDropdown;